import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Breadcrums from "../../common/breadcrumbs";
import { rewardConfigDetails } from "../../services/reward-config.services";
import Loader from "../../common/loader";

const RewardConfigView = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [pageLoader, setPageLoader] = useState(true);

  const breadcrumbs = [
    { title: t("link_dashboard"), url: "/admin/dashboard" },
    {
      title: t("Reward Management"),
      url: "/admin/reward-management/reward-config/list/1",
    },
    { title: t("View Reward Config"), url: "" },
  ];

  useEffect(() => {
    fetchDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const fetchDetails = () => {
    setPageLoader(true);
    rewardConfigDetails(id)
      .then((res) => {
        if (res.success) {
          setData(res.data);
        }
        setPageLoader(false);
      })
      .catch((err) => {
        console.log(err);
        setPageLoader(false);
      });
  };

  if (pageLoader) {
    return <Loader />;
  }

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="animation_fade">
        <div className="card custom-card">
          <div className="card-header border-bottom">
            <h6 className="main-content-label mb-0">
              {t("View Reward Config")}
            </h6>
          </div>
          <div className="card-body">
            {data ? (
              <div className="row">
                <div className="col-md-6 form-group">
                  <label className="font-weight-bold">{t("Type")}</label>
                  <p>
                    {data.type === "level_completion"
                      ? "Level Completion"
                      : data.type === "streak_bonus"
                        ? "Streak Bonus"
                        : data.type === "milestone_achievement"
                          ? "Milestone Achievement"
                          : data.type === "badge_definition"
                            ? "Badge Definition"
                            : data.type}
                  </p>
                </div>
                <div className="col-md-6 form-group">
                  <label className="font-weight-bold">{t("Title")}</label>
                  <p>{data.title || "N/A"}</p>
                </div>
                <div className="col-md-12 form-group">
                  <label className="font-weight-bold">{t("Description")}</label>
                  <p>{data.description || "N/A"}</p>
                </div>
                <div className="col-md-6 form-group">
                  <label className="font-weight-bold">{t("Reward Type")}</label>
                  <p className="text-capitalize">{data.reward_type || "N/A"}</p>
                </div>
                <div className="col-md-6 form-group">
                  <label className="font-weight-bold">{t("Value")}</label>
                  <p>{data.value || "N/A"}</p>
                </div>
                <div className="col-md-6 form-group">
                  <label className="font-weight-bold">{t("Status")}</label>
                  <p>
                    {data.is_active ? (
                      <span className="badge badge-success">Active</span>
                    ) : (
                      <span className="badge badge-secondary">Inactive</span>
                    )}
                  </p>
                </div>

                {data.criteria && (
                  <>
                    <div className="col-12 mt-4">
                      <h6>{t("Criteria")}</h6>
                      <hr />
                    </div>
                    {data.type === "level_completion" && (
                      <>
                        <div className="col-md-6 form-group">
                          <label className="font-weight-bold">
                            {t("Min Score")}
                          </label>
                          <p>{data.criteria.min_score || "N/A"}</p>
                        </div>
                        <div className="col-md-6 form-group">
                          <label className="font-weight-bold">
                            {t("Min Accuracy")}
                          </label>
                          <p>{data.criteria.min_accuracy || "N/A"}</p>
                        </div>
                      </>
                    )}
                    {data.type === "streak_bonus" && (
                      <div className="col-md-6 form-group">
                        <label className="font-weight-bold">
                          {t("Streak Days")}
                        </label>
                        <p>{data.criteria.streak_days || "N/A"}</p>
                      </div>
                    )}
                    {data.type === "milestone_achievement" && (
                      <>
                        <div className="col-md-6 form-group">
                          <label className="font-weight-bold">
                            {t("Total Games")}
                          </label>
                          <p>{data.criteria.total_games || "N/A"}</p>
                        </div>
                        <div className="col-md-6 form-group">
                          <label className="font-weight-bold">
                            {t("Milestone Type")}
                          </label>
                          <p>{data.criteria.milestone_type || "N/A"}</p>
                        </div>
                      </>
                    )}
                  </>
                )}

                <div className="col-12 text-right mt-3">
                  <button
                    type="button"
                    onClick={() => navigate(-1)}
                    className="btn btn-secondary mr-2"
                  >
                    {t("btn_back")}
                  </button>
                  <Link
                    to={`/admin/reward-management/reward-config/1/edit/${data._id}`}
                    className="btn btn-main-primary"
                  >
                    {t("btn_edit")}
                  </Link>
                </div>
              </div>
            ) : (
              <div className="text-center">{t("msg_no_records")}</div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default RewardConfigView;
